<article class="viewerAsset viewerAssetVideo mx-auto">
  <div class="viewerAssetVideoWrapper mx-auto" id="viewerAssetVideoWrapper"
  [style.--video-width]="videoWidth"
  [style.--video-height]="videoHeight">
    <span #wistiaContainer class="viewer-wistia-container">
      <zbp-branded-wistia *ngIf="!componentRef"
                          [isViewerFullScreen]="false"
                          [isViewer]="true"
                          [wistiaCode]="asset.fileName"
                          (videoReady)="setLoaded()"
                          (videoError)="setError()"
                          (videoEnded)="setComplete()"
                          (videoDimensions)="loadVideoDimensions($event)"
      />
    </span>
  </div>
</article>
